<template>
  <div></div>
</template>
<script>
import urlSettings from '@/config/url-settings.js';
import { getStore } from '@/util/store.js';

export default {
  data() {
    return {
      linkUrl: '',
      loginParams: {
        username: 'KYadmin',
        password: 'Kyadmin123#',
        tenantId: '',
      },
    };
  },
  created() {
    this.linkUrl = decodeURIComponent(this.$route.query.linkUrl || '');
    if (getStore({ name: 'token' })) {
      this.goLinkUrl();
      return;
    }
    this.getTenant();
    const loading = this.$loading({
      lock: true,
      text: '加载中',
      spinner: 'el-icon-loading',
    });
    this.$store
      .dispatch('LoginByUsername', this.loginParams)
      .then(() => {
        this.$store.dispatch('GetMenu').then((data) => {
          if (data.length !== 0) {
            this.$router.$avueRouter.formatRoutes(data, true);
          }
          this.goLinkUrl();
          loading.close();
        });
      })
      .catch(() => {
        this.loginFailed();
        loading.close();
      });
  },
  methods: {
    getTenant() {
      if (urlSettings.TENANTID) {
        this.loginParams.tenantId = urlSettings.TENANTID;
      } else {
        this.loginFailed();
      }
    },
    loginFailed() {
      this.$message.error('登录异常');
      this.$router.replace('/login');
    },
    goLinkUrl() {
      if (this.linkUrl) {
        this.$router.replace(this.linkUrl);
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>